import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

export const Icon = styled.i`
  font-style: normal;
  display: flex;
  align-items: center;
  ${({ variant, modifier }) => setStyleSvgPath(variant, modifier)}
  ${({ cursor }) =>
    css`
      cursor: ${cursor};
    `}
`;

const setStyleSvgPath = (variant, modifier) => {
  return css`
    svg {
      path {
        fill: ${theme.colors[variant]?.ic[modifier]};
      }
    }
  `;
};
